import React, { useState, useRef, useEffect } from 'react'

const font = "'DM Sans', sans-serif"

function BreadcrumbDropdown({ label, value, name, options, onChange, icon, placeholder, searchPlaceholder = 'Search...' }) {
  const [open, setOpen] = useState(false)
  const [query, setQuery] = useState('')
  const ref = useRef(null)
  const inputRef = useRef(null)

  const optionsList = Array.isArray(options) ? options : []

  useEffect(() => {
    if (!open) return
    setQuery('')
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false) }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [open])

  useEffect(() => {
    if (open && inputRef.current) inputRef.current.focus()
  }, [open])

  const filtered = optionsList.filter((opt) =>
    (opt.name || '').toLowerCase().includes((query || '').trim().toLowerCase())
  )

  // If options have id, value is the selected id → show name; otherwise value is the display text
  const hasIdKey = optionsList.some((opt) => opt.id != null)
  const selectedOption = optionsList.find((opt) => opt.id != null && String(opt.id) === String(value))
  const displayText = selectedOption ? selectedOption.name : (hasIdKey ? '' : (name ?? ''))

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <div onClick={() => setOpen((p) => !p)} style={{
        display: 'flex', alignItems: 'center', gap: 6, padding: '4px 10px', borderRadius: 6, cursor: 'pointer',
        background: open ? 'rgba(255,255,255,0.08)' : 'transparent',
        transition: 'background 0.15s',
      }}>
        {icon && <span style={{ fontSize: 12, opacity: 0.5 }}>{icon}</span>}
        <span style={{ fontSize: 13, fontWeight: (displayText ? 600 : 400), color: displayText ? '#f1f5f9' : '#6b7a90', fontStyle: displayText ? 'normal' : 'italic', fontFamily: font }}>{displayText || placeholder}</span>
        <span style={{ fontSize: 10, color: '#6b7a90', marginLeft: 2, transition: 'transform 0.2s', transform: open ? 'rotate(180deg)' : 'none' }}>▾</span>
      </div>
      {open && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, marginTop: 4, minWidth: 200,
          background: '#ffffff', border: '1px solid rgba(0,0,0,0.08)',
          borderRadius: 10, overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', zIndex: 9999,
        }}>
          {label && (
            <div style={{ padding: '8px 12px 4px', fontSize: 10, color: '#7a7a7a', textTransform: 'uppercase', letterSpacing: 1, fontFamily: font }}>{label}</div>
          )}
          <div style={{ padding: '4px 8px 8px' }} onClick={(e) => e.stopPropagation()}>
            <input
              ref={inputRef}
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder={searchPlaceholder}
              style={{
                width: '100%', boxSizing: 'border-box', padding: '6px 10px', borderRadius: 8,
                border: '1px solid rgba(0,0,0,0.08)', background: '#fafafa',
                color: '#363636', fontSize: 12, fontFamily: font, outline: 'none',
              }}
            />
          </div>
          <div style={{ maxHeight: 220, overflowY: 'auto', overflowX: 'hidden' }}>
          {filtered.length === 0 ? (
            <div style={{ padding: '12px', fontSize: 12, color: '#7a7a7a', fontFamily: font }}>No matches</div>
          ) : (
            filtered.map((opt) => {
              const isSelected = hasIdKey ? (opt.id != null && String(opt.id) === String(value)) : (opt.name === value)
              return (
              <div
                key={opt.id ?? opt.name}
                onClick={() => { onChange(opt); setOpen(false) }}
                style={{
                  padding: '8px 12px', cursor: 'pointer', fontSize: 13, fontFamily: font,
                  color: isSelected ? '#ff4b4f' : '#5a5a5a',
                  background: isSelected ? 'rgba(255,75,79,0.08)' : 'transparent',
                  transition: 'background 0.15s ease',
                  display: 'flex', alignItems: 'center', gap: 8,
                }}
              >
                {opt.name}
                {opt.led && (
                  <span style={{
                    width: 7, height: 7, borderRadius: '50%', flexShrink: 0, marginLeft: 'auto',
                    background: opt.led === 'green' ? '#22c55e' : opt.led === 'orange' ? '#f59e0b' : opt.led,
                    boxShadow: opt.led === 'green' ? '0 0 6px rgba(34,197,94,0.4)' : opt.led === 'orange' ? '0 0 6px rgba(245,158,11,0.4)' : 'none',
                    animation: opt.ledPulse ? 'statusPulse 1.5s ease-in-out infinite' : 'none',
                  }}
                  />
                )}
              </div>
            )
            })
          )}
          </div>
        </div>
      )}
    </div>
  )
}

export default BreadcrumbDropdown
